import { useGetWorkScheduleForAProcess } from "reports/components/Reports/reportUtils";
import LoadingCircle from "reports/components/simple/LoadingCircle";
import {
  useGetWorkScheduleShiftList,
  useGetWorkScheduleShiftListJson,
} from "reports/utils/workScheduleConfigJsonUtils";
import WeekToDatePipeline from "./WeekToDatePipeline";
import { useGetWeekToDateProps } from "./WeekToDateUtils";

export default function WeekToDateReportRoute() {
  const WeekToDateProps = useGetWeekToDateProps();
  const work_schedule_id = useGetWorkScheduleForAProcess(
    WeekToDateProps.machemetryId
  );

  // The report starts on Monday and hence we need to get all the Shifts for Monday and hence ordinal = 1
  useGetWorkScheduleShiftList({
    work_schedule_id: work_schedule_id,
    ordinal: 1,
  });

  const shifts = useGetWorkScheduleShiftListJson();

  return shifts ? (
    <WeekToDatePipeline {...WeekToDateProps} shifts={shifts} />
  ) : (
    <LoadingCircle />
  );
}
